export default __webpack_public_path__ + "c1cf1e38e4f794855311ba07b419e06e.png";